if (!customElements.get("fabric-video-drawer")) {
  class FabricVideoDrawer extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("[data-fabric-video]");
      document.querySelectorAll("[data-fabric-video-trigger]").forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.setVideo(trigger);
        });
      });

      window.addEventListener("drawerClosed", (event) => {
        if (event.detail.id === "drawer-fabric-video" && this.video) {
          this.video.pause();
        }
      });
    }

    setVideo(trigger) {
      if (!this.video || !trigger.dataset.fabricVideoSrc) return;

      const source = this.video.querySelector("source") || document.createElement("source");
      source.type = "video/mp4";
      source.src = trigger.dataset.fabricVideoSrc;

      if (!source.parentElement) {
        this.video.appendChild(source);
      }

      this.video.poster = trigger.dataset.fabricVideoPoster || "";

      this.video.load();
      this.video.play().catch(() => {});
    }
  }

  customElements.define("fabric-video-drawer", FabricVideoDrawer);
}
